import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('Answer')
export default class Answer {
  constructor() {
    this.version = undefined;
    this.order = undefined;
    this.choiceCodes = [];
    this.answer = '';
  }

  @JsonProperty('question_version')
  public version?: number;

  @JsonProperty('order')
  public order?: number;

  @JsonProperty('choice_codes', [String])
  public choiceCodes: string[];

  @JsonProperty('answer', null, true)
  public answer: string;
}
